import { useEffect, useRef, useState } from 'react'
import { useNavigation } from 'react-router'
import { useSpinDelay } from 'spin-delay'
import { cn } from '#app/utils/misc.tsx'

const imageSize = 75

function EpicProgress() {
  const transition = useNavigation()
  const busy = transition.state !== 'idle'
  const delayedPending = useSpinDelay(busy, {
    delay: 600,
    minDuration: 400,
  })
  const ref = useRef<HTMLDivElement>(null)
  const [animationComplete, setAnimationComplete] = useState(true)

  useEffect(() => {
    if (!ref.current) return
    if (delayedPending) setAnimationComplete(false)

    const animationPromises = ref.current
      .getAnimations()
      .map(({ finished }) => finished)

    void Promise.allSettled(animationPromises).then(() => {
      if (!delayedPending) setAnimationComplete(true)
    })
  }, [delayedPending])

  return (
    <>
      <div
        className={cn(
          'fixed top-0 right-0 bottom-0 left-0 z-30 h-full w-full',
          busy && 'block',
          !busy && 'hidden',
        )}
        style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)' }}
      />
      <div
        role="progressbar"
        aria-hidden={delayedPending ? undefined : true}
        aria-valuetext={delayedPending ? 'Loading' : undefined}
        className="fixed z-50 h-[0.20rem]"
        style={{
          left: `calc(50% - ${imageSize / 2}px)`,
          top: `calc(50% - ${imageSize / 2}px)`,
        }}
      >
        <div
          ref={ref}
          className={cn(
            'bg-foreground h-full w-0 duration-500 ease-in-out',
            transition.state === 'idle' &&
              (animationComplete
                ? 'transition-none'
                : 'w-full opacity-0 transition-all'),
            delayedPending && transition.state === 'submitting' && 'w-5/12',
            delayedPending && transition.state === 'loading' && 'w-8/12',
          )}
        />
        {delayedPending && (
          <div
            className="absolute flex items-center justify-center"
            style={{ width: `${imageSize}px`, height: `${imageSize}px` }}
          >
            <img src="/img/loading-animation.gif" alt="" />
          </div>
        )}
      </div>
    </>
  )
}

export { EpicProgress }
